export const SAMPLE_IMAGE_SETS = {
  beach: [
    {
      src: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1080&h=1440&auto=format&fit=crop",
      width: 1080,
      height: 1440,
    },
    {
      src: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?q=80&w=1080&h=1440&auto=format&fit=crop",
      width: 1080,
      height: 1440,
    },
  ],
  mountains: [
    {
      src: "https://images.unsplash.com/photo-1756752358819-23f00a84ee7b?q=80&w=1080&h=1440&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      width: 1080,
      height: 1440,
    },
    {
      src: "https://images.unsplash.com/photo-1755398104393-746e52af4a9f?q=80&w=1080&h=1440&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      width: 1080,
      height: 1440,
    },
    {
      src: "https://images.unsplash.com/photo-1755389521304-51d55cec52d6?q=80&w=1080&h=1440&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      width: 1080,
      height: 1440,
    },
    {
      src: "https://images.unsplash.com/photo-1760532780081-a26e9d92da80?q=80&w=1080&h=1440&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      width: 1080,
      height: 1440,
    },
  ],
  urban: [
    {
      src: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=80&w=1080&h=1440&auto=format&fit=crop",
      width: 1080,
      height: 1440,
    },
  ],
};

export function getRandomImageSet() {
  const sets = Object.values(SAMPLE_IMAGE_SETS);
  return sets[Math.floor(Math.random() * sets.length)];
}

export function getImageSetByType(type) {
  return SAMPLE_IMAGE_SETS[type] || [];
}
